<script>
  import { onMount } from 'svelte'
  import L from 'leaflet'
  import 'leaflet/dist/leaflet.css'

  export let start = [-33.440257242872434, -70.841459559616412]
  export let end = [-33.405457716223395, -70.5981734942654]

  let map
  let route
  let coordinates = []

  function addPoint(lat, lng) {
    coordinates.push([lat, lng])
    route.setLatLngs(coordinates)
    map.fitBounds(route.getBounds())
  }

  async function callCordinates() {
    const routeApiUrl = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=5b3ce3597851110001cf6248a82ebcf9fc6649739e4007f294750aaa&start=${start[1]},${start[0]}&end=${end[1]},${end[0]}`
    try {
      const res = await fetch(routeApiUrl)
      const data = await res.json()
      const coords = data.features[0].geometry.coordinates.map((coord) => [
        coord[1],
        coord[0],
      ])
      // Crea el mapa en el contenedor del componente
      map = L.map('mapContainer').setView([-33.4489, -70.6693], 14)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '© Enteleqqia contributors',
      }).addTo(map)
      L.circle(start, {
        color: 'blue',
        fillColor: '#0f6bff',
        fillOpacity: 0.5,
        radius: 1000,
      }).addTo(map)
      L.circle(end, {
        color: 'blue',
        fillColor: '#0f6bff',
        fillOpacity: 0.5,
        radius: 1000,
      }).addTo(map)
      route = L.polyline([], { color: 'red' }).addTo(map)
      coords.forEach((coord) => addPoint(coord[0], coord[1]))
    } catch (error) {
      console.log('Error fetching coordinates:', error)
    }
  }

  onMount(() => {
    callCordinates()
  })
</script>

<div id="mapContainer" style="height: 500px;"></div>
